import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GameWrapper } from "./modules/components/games-wrapper/game-wrapper";
import { RedirectPage } from "./modules/components/redirect/redirect";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/:game" element={<GameWrapper />} />
          <Route path="/:skin/:game" element={<GameWrapper />} />
          <Route path="*" element={<RedirectPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
